import { Box, Flex, Text } from "@chakra-ui/react";
import React, { useMemo } from "react";
import { substituteSampleValues } from "../../../modules/admin-modules/whatsapp-templates/utils";

const TemplatePreviewBubble = ({
  bodyContent = "",
  sampleValues = {},
  displayName = "",
}) => {
  const previewText = useMemo(
    () => substituteSampleValues(bodyContent, sampleValues),
    [bodyContent, sampleValues]
  );

  return (
    <Box
      bg="#0b141a"
      borderRadius="16px"
      p={4}
      minH="280px"
      backgroundImage="radial-gradient(rgba(255,255,255,0.04) 1px, transparent 1px)"
      backgroundSize="18px 18px"
    >
      <Text color="rgba(255,255,255,0.55)" fontSize="xs" mb={3}>
        Preview{displayName ? ` · ${displayName}` : ""}
      </Text>
      <Flex justify="flex-start">
        <Box
          maxW="90%"
          bg="#202c33"
          color="#e9edef"
          px={3}
          py={2}
          borderRadius="8px"
          borderTopLeftRadius="0"
          boxShadow="sm"
          whiteSpace="pre-wrap"
          fontSize="sm"
          lineHeight="1.5"
          fontFamily="'Segoe UI', Tahoma, sans-serif"
        >
          {previewText || (
            <Text as="span" color="rgba(233,237,239,0.45)">
              Body content will appear here…
            </Text>
          )}
        </Box>
      </Flex>
    </Box>
  );
};

export default TemplatePreviewBubble;
